import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import PrivateMenu from "../sections/Header/privateMenuUp";
import PrivateMenuUp from "../sections/Header/privateMenuUp";
import PrivateMenuLeft from "../sections/Header/privateMenuLeft";
import useAuth from "../../../components/hooks/useAuth";
import DashboardCampaignListComponent from "./campaign";
import "./Dashboard.css";
import LinkedZapDashBoard from "../LinkedZapDashBoard";
import { Helmet } from "react-helmet";

const DashboardComponent = () => {
  const { sidebarOpen, user } = useAuth();

  return (
    <div className="dashboard-container">
      <PrivateMenuLeft />
      <PrivateMenuUp />

      <Helmet>
        <title>{`DashBoard - Notify Flow`}</title>
      </Helmet>

      <div
        className={`main-dashboard-content ${sidebarOpen ? "sidebar-open" : "sidebar-closed"
          }`}
      >
        <div className="dashboard-inner">
          <h2>Bem-vindo, {user.name}!</h2>
          <p>Crie sua campanha agora.</p>

          <div className="row g-4 mt-2 dashboard-row">
            <div className="col-12 col-lg-6">
              <div className="card shadow-sm h-100 card-campaign">
                <DashboardCampaignListComponent />
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="card shadow-sm h-100 card-contas-conectadas">
                <LinkedZapDashBoard />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardComponent;
